import React from 'react';
import {StyledTitle} from "./Title.styles";

export const Title: React.FC = (props) => {
    return <StyledTitle {...props}/>
};
